import request from '@/http/request'
import { getMajorList } from '@/http/api/category'

export default {
  name: 'Keywords',
  data() {
    return {
      allCategories: [], // 所有分类列表
      categories: [], // 当前显示的分类列表
      keywordsByCategory: {}, // 按分类存储的词条
      keywordsCounts: {}, // 每个分类的词条总数
      currentPage: {}, // 每个分类的当前页码
      hasMore: {}, // 每个分类是否还有更多数据
      loading: {}, // 每个分类的加载状态
      initialLoading: true, // 初始加载状态
      loadingMoreCategories: false, // 是否正在加载更多分类
      initialLoadCount: 50, // 初始加载的分类数量
      loadBatchSize: 15, // 每次懒加载的分类数量
      scrollTimeout: null, // 滚动防抖定时器
      // 搜索相关数据
      searchQuery: '', // 搜索输入内容
      searchResults: [], // 搜索结果
      showDropdown: false, // 是否显示下拉框
      searchTimeout: null, // 搜索防抖定时器
      // 相关词条数据
      relatedCategories: [], // 搜索选中词条的相关分类
      highlightKeywords: [], // 需要高亮的关键词列表
      // 连接线数据
      containerWidth: 0, // 容器宽度
      containerHeight: 0, // 容器高度
      connectionLines: [], // 连接线路径数据
      // 标签颜色映射 - 根据一级分类 major_id（共12种）
      labelColors: {
        '1': '#DBE2F2',  // 哲学门类
        '2': '#FFF3CC',  // 经济学门类
        '3': '#FFE6F5',  // 法学门类
        '4': '#ADF5CE',  // 教育学门类
        '5': '#E8F5E9',  // 文学门类
        '6': '#FFF9C4',  // 历史学门类
        '7': '#F3E5F5',  // 理学门类
        '8': '#E1F5FE',  // 工学门类
        '9': '#FCE4EC',  // 农学门类
        '10': '#F1F8E9', // 医学门类
        '11': '#FFF3E0', // 管理学门类
        '12': '#EFEBE9'  // 艺术学门类
      },
      // 当前激活的弹窗
      activePopoverCategoryId: null // 当前显示弹窗的分类ID
    }
  },
  computed: {
    // 检查是否还有更多分类可以加载
    hasMoreCategories() {
      return this.categories.length < this.allCategories.length
    }
  },
  created() {
    this.fetchCategories()
  },
  mounted() {
    // 添加滚动监听 - 延迟执行确保DOM渲染完成
    this.$nextTick(() => {
      // 延迟查找容器，确保条件渲染完成
      setTimeout(() => {
        const contentContainer = this.$el.querySelector('.keywords-content')
        if (contentContainer) {
          this.contentContainer = contentContainer
          // 绑定滚动事件，使用箭头函数确保this指向正确
          this.handleScrollBound = this.handleScroll.bind(this)
          this.contentContainer.addEventListener('scroll', this.handleScrollBound)
        }
      }, 500) // 延迟500ms等待数据加载和DOM更新
    })
    
    // 添加窗口大小变化监听
    this.handleResizeBound = this.handleResize.bind(this)
    window.addEventListener('resize', this.handleResizeBound)
  },
  beforeDestroy() {
    // 移除滚动监听
    if (this.contentContainer && this.handleScrollBound) {
      this.contentContainer.removeEventListener('scroll', this.handleScrollBound)
    }
    // 移除窗口大小变化监听
    if (this.handleResizeBound) {
      window.removeEventListener('resize', this.handleResizeBound)
    }
    // 清理防抖定时器
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout)
    }
    // 清理搜索防抖定时器
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  },
  methods: {
    // 处理滚动事件（添加防抖）
    handleScroll() {
      if (this.loadingMoreCategories) return
      
      // 清除之前的定时器
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout)
      }
      
      // 设置防抖延迟
      this.scrollTimeout = setTimeout(() => {
        const container = this.contentContainer
        if (!container) return
        
        const scrollLeft = container.scrollLeft
        const scrollWidth = container.scrollWidth
        const clientWidth = container.clientWidth
        
        // 当滚动到接近右端时（距离右端100px以内）触发加载更多
        const threshold = 100
        if (scrollLeft + clientWidth >= scrollWidth - threshold && this.hasMoreCategories) {
          this.loadMoreCategories()
        }
      }, 50) // 减少防抖延迟到50ms，提高响应速度
    },
    
    // 获取分类列表
    async fetchCategories() {
      try {
        // 使用新的专业大类接口
        const response = await getMajorList()
        
        console.log('接口响应数据:', response)
        
        // 判断数据格式：可能是直接返回数组，也可能包裹在 result 中
        let dataArray = null
        if (Array.isArray(response)) {
          // 直接返回数组
          dataArray = response
        } else if (response && response.result && Array.isArray(response.result)) {
          // 包裹在 result 中
          dataArray = response.result
        }
        
        if (dataArray) {
          const allSecondaryCategories = []
          
          console.log('一级分类数量:', dataArray.length)
          
          // 遍历一级分类，提取所有二级分类
          dataArray.forEach(primaryCategory => {
            console.log('一级分类:', primaryCategory.major_name, '子分类数量:', primaryCategory.children?.length || 0)
            
            if (primaryCategory.children && Array.isArray(primaryCategory.children)) {
              primaryCategory.children.forEach(secondaryCategory => {
                allSecondaryCategories.push({
                  classify_id: secondaryCategory.major_id, // 二级分类ID
                  classify_name: secondaryCategory.major_name, // 二级分类名称
                  parent_id: primaryCategory.major_id, // 一级分类ID（用于颜色映射）
                  parent_name: primaryCategory.major_name, // 一级分类名称
                  label: String(primaryCategory.major_id), // 使用一级分类ID作为标签
                  labelColor: this.getLabelColor(String(primaryCategory.major_id))
                })
              })
            }
          })
          
          console.log('二级分类总数:', allSecondaryCategories.length)
          console.log('二级分类示例:', allSecondaryCategories.slice(0, 3))
          
          this.allCategories = allSecondaryCategories
          
          // 初始化所有分类的状态
          this.allCategories.forEach(category => {
            this.$set(this.keywordsByCategory, category.classify_id, [])
            this.$set(this.currentPage, category.classify_id, 1)
            this.$set(this.hasMore, category.classify_id, true)
            this.$set(this.loading, category.classify_id, false)
            this.$set(this.keywordsCounts, category.classify_id, 0)
          })
          
          // 只显示初始数量的分类
          this.loadInitialCategories()
        } else {
          console.error('响应数据格式不正确:', response)
        }
      } catch (error) {
        console.error('获取分类失败:', error)
        this.$message.error('获取分类失败')
      } finally {
        this.initialLoading = false
      }
    },
    
    // 加载初始分类数据
    async loadInitialCategories() {
      const initialCategories = this.allCategories.slice(0, this.initialLoadCount)
      this.categories = [...initialCategories]
      
      // 获取这些分类的第一页词条
      await this.fetchCategoriesKeywords(initialCategories)
    },
    
    // 加载更多分类
    async loadMoreCategories() {
      if (this.loadingMoreCategories) {
        return
      }
      
      const currentCount = this.categories.length
      const remainingCategories = this.allCategories.slice(currentCount, currentCount + this.loadBatchSize)
      
      if (remainingCategories.length === 0) {
        return
      }
      
      this.loadingMoreCategories = true
      
      try {
        // 添加新分类到显示列表
        this.categories.push(...remainingCategories)
        
        // 获取新分类的词条数据
        await this.fetchCategoriesKeywords(remainingCategories)
      } catch (error) {
        console.error('加载更多分类失败:', error)
        this.$message.error('加载更多分类失败')
      } finally {
        this.loadingMoreCategories = false
      }
    },
    
    // 获取指定分类列表的第一页词条
    async fetchCategoriesKeywords(categoriesList) {
      // 限制并发请求数量，避免服务器压力过大
      const batchSize = 3 // 减少并发数量以提高性能
      for (let i = 0; i < categoriesList.length; i += batchSize) {
        const batch = categoriesList.slice(i, i + batchSize)
        const promises = batch.map(category => 
          this.fetchKeywords(category.classify_id, 1, false)
        )
        await Promise.all(promises)
        // 每批次之间稍作延迟，让UI有时间更新
        if (i + batchSize < categoriesList.length) {
          await new Promise(resolve => setTimeout(resolve, 150))
        }
      }
    },
    
    // 获取指定分类的词条
    async fetchKeywords(classifyId, page = 1, isLoadMore = true) {
      if (this.loading[classifyId]) return
      
      this.$set(this.loading, classifyId, true)
      
      try {
        const response = await request('/api/Keywords/getKeywordsListByCategory', {
          page,
          limit: 20,
          classify_id: classifyId
        }, 'get')
        
        // 适配新的接口格式：response.result.list 和 response.result.count
        let list = []
        let count = 0
        
        if (response && response.result) {
          // 新格式：{ code: 200, result: { list: [...], count: 170 }, message: "" }
          list = response.result.list || []
          count = response.result.count || 0
        } else if (response && response.list) {
          // 旧格式兼容：{ list: [...], count: 170 }
          list = response.list || []
          count = response.count || 0
        }
        
        if (Array.isArray(list)) {
          if (isLoadMore) {
            // 追加数据
            this.$set(this.keywordsByCategory, classifyId, [
              ...this.keywordsByCategory[classifyId],
              ...list
            ])
          } else {
            // 替换数据
            this.$set(this.keywordsByCategory, classifyId, list)
          }
          
          this.$set(this.keywordsCounts, classifyId, count)
          this.$set(this.currentPage, classifyId, page)
          
          // 判断是否还有更多数据
          const currentTotal = this.keywordsByCategory[classifyId].length
          this.$set(this.hasMore, classifyId, currentTotal < count)
        }
      } catch (error) {
        console.error('获取词条失败:', error)
        this.$message.error(`获取分类 ${classifyId} 的词条失败`)
      } finally {
        this.$set(this.loading, classifyId, false)
      }
    },
    
    // 加载更多词条
    loadMoreKeywords(classifyId) {
      const nextPage = this.currentPage[classifyId] + 1
      this.fetchKeywords(classifyId, nextPage, true)
    },
    
    // 刷新数据
    async refreshData() {
      this.initialLoading = true
      // 重置所有状态
      this.allCategories.forEach(category => {
        this.$set(this.keywordsByCategory, category.classify_id, [])
        this.$set(this.currentPage, category.classify_id, 1)
        this.$set(this.hasMore, category.classify_id, true)
        this.$set(this.keywordsCounts, category.classify_id, 0)
      })
      // 重新加载初始分类
      await this.loadInitialCategories()
      this.initialLoading = false
      this.$message.success('刷新成功')
    },
    
    // 点击词条项
    onKeywordClick(keyword, categoryId) {
      // 更新当前激活的弹窗分类ID
      this.activePopoverCategoryId = categoryId
      // 这里可以添加点击词条后的其他逻辑
    },
    
    // 点击分类柱体
    onCategoryClick(category) {
      // 这里可以添加点击分类后的逻辑
    },
    
    // 获取柱体高度（撑满屏幕）
    getColumnHeight(categoryId) {
      return 'calc(100vh - 200px)'
    },
    
    // 提取中文名称
    getChineseName(fullName) {
      if (!fullName) return ''
      // 匹配中文字符，去掉英文部分
      const chineseMatch = fullName.match(/[\u4e00-\u9fa5]+/g)
      if (chineseMatch) {
        return chineseMatch.join('')
      }
      return fullName
    },
    
    // 根据标签获取颜色
    getLabelColor(label) {
      return this.labelColors[label] || this.labelColors['1']
    },
    
    // 根据标签获取知识类型描述
    getLabelDescription(label) {
      const descriptions = {
        '1': '哲学门类',
        '2': '经济学门类', 
        '3': '法学门类',
        '4': '教育学门类',
        '5': '文学门类',
        '6': '历史学门类',
        '7': '理学门类',
        '8': '工学门类',
        '9': '农学门类',
        '10': '医学门类',
        '11': '管理学门类',
        '12': '艺术学门类'
      }
      return descriptions[label] || '未知门类'
    },

    // 搜索输入处理（防抖）
    handleSearchInput() {
      // 清除之前的定时器
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }
      
      // 如果输入为空，清空搜索结果
      if (!this.searchQuery.trim()) {
        this.searchResults = []
        this.showDropdown = false
        return
      }

      // 设置防抖延迟
      this.searchTimeout = setTimeout(() => {
        this.performSearch()
      }, 300) // 300ms延迟
    },
    
    // 执行搜索
    async performSearch() {
      try {
        const response = await request('/api/books/getContentForSearch', {
          search_type: 'all', // 搜索所有类型
          search_words: this.searchQuery,
          page: 1,
          limit: 20
          }, 'get')
        
        if (response && response.keywords_list) {
          // 过滤出book_keywords_id不为空的关键词
          this.searchResults = response.keywords_list.filter(item => 
            item.book_keywords_id && item.book_keywords_id !== '' && item.book_keywords_id !== null
          )
          this.showDropdown = true
        } else {
          // 如果没有keywords_list，设置为空数组
          this.searchResults = []
          this.showDropdown = false
        }
      } catch (error) {
        console.error('搜索失败:', error)
        this.$message.error('搜索失败，请稍后重试')
        this.searchResults = []
        this.showDropdown = false
      }
    },
    
    // 选择搜索结果
    async selectKeyword(keyword) {
      this.searchQuery = keyword.keywords
      this.showDropdown = false
      
      try {
        // 在新搜索前，先清除之前的相关分类
        this.clearRelatedCategoriesQuietly()
        
        // 调用词条详情接口获取相关信息，传递搜索的词条本身
        await this.fetchKeywordDetails(keyword.book_keywords_id, keyword.keywords)
        
        // 等待DOM更新后，自动显示第一个高亮词条的描述框
        this.$nextTick(() => {
          setTimeout(() => {
            this.showFirstHighlightedKeywordPopover()
          }, 800) // 延迟800ms确保连接线绘制完成和词条渲染完成
        })
      } catch (error) {
        console.error('获取词条详情失败:', error)
        this.$message.error('获取词条详情失败')
      }
    },
    
    // 获取词条详情和相关分类
    async fetchKeywordDetails(bookKeywordsId, searchedKeyword) {
      try {
        const response = await request('/api/Keywords/getKeywordsinfoById', {
          book_keywords_id: bookKeywordsId
        }, 'get')
        
        // 修复：直接使用response，而不是response.result
        if (response && (response.book_keywords_info || response.keywords_line_list)) {
          // 解析相关分类信息，传递搜索的词条
          await this.parseAndAddRelatedCategories(response, searchedKeyword)
        }
      } catch (error) {
        console.error('获取词条详情失败:', error)
        throw error
      }
    },
    
    // 解析并添加相关分类
    async parseAndAddRelatedCategories(result, searchedKeyword) {
      const classifyIdSet = new Set() // 用于去重分类ID
      const highlightKeywordsSet = new Set() // 收集需要高亮的关键词
      
      // 首先添加搜索的词条本身到高亮列表
      if (searchedKeyword) {
        highlightKeywordsSet.add(searchedKeyword.trim())
      }
      
      // 从book_keywords_info中提取分类ID和词条名称
      if (result.book_keywords_info) {
        // 添加主词条名称
        if (result.book_keywords_info.keywords) {
          highlightKeywordsSet.add(result.book_keywords_info.keywords.trim())
        }
        
        // 提取分类ID
        if (result.book_keywords_info.classify_list) {
          result.book_keywords_info.classify_list.forEach(classify => {
            // 兼容不同的字段名：major_id 或 id
            const classifyId = classify.major_id || classify.id
            if (classifyId) {
              classifyIdSet.add(classifyId)
            }
          })
        }
      }
      
      // 从keywords_line_list中提取分类ID和需要高亮的关键词
      if (result.keywords_line_list && Array.isArray(result.keywords_line_list) && result.keywords_line_list.length > 0) {
        result.keywords_line_list.forEach(line => {
          // 从keywords_front中提取
          if (line.keywords_front) {
            // 收集需要高亮的关键词（去除首尾空格）
            if (line.keywords_front.keywords) {
              highlightKeywordsSet.add(line.keywords_front.keywords.trim())
            }
            
            if (line.keywords_front.classify_list) {
              line.keywords_front.classify_list.forEach(classify => {
                // 兼容不同的字段名：major_id 或 id
                const classifyId = classify.major_id || classify.id
                if (classifyId) {
                  classifyIdSet.add(classifyId)
                }
              })
            }
          }
          
          // 从keywords_behind中提取
          if (line.keywords_behind) {
            // 收集需要高亮的关键词（去除首尾空格）
            if (line.keywords_behind.keywords) {
              highlightKeywordsSet.add(line.keywords_behind.keywords.trim())
            }
            
            if (line.keywords_behind.classify_list) {
              line.keywords_behind.classify_list.forEach(classify => {
                // 兼容不同的字段名：major_id 或 id
                const classifyId = classify.major_id || classify.id
                if (classifyId) {
                  classifyIdSet.add(classifyId)
                }
              })
            }
          }
        })
      }
      
      // 保存需要高亮的关键词
      this.highlightKeywords = Array.from(highlightKeywordsSet)
      
      console.log('提取的分类ID集合:', Array.from(classifyIdSet))
      console.log('需要高亮的关键词:', this.highlightKeywords)
      
      // 从allCategories中查找匹配的完整分类信息
      const relatedCategories = []
      classifyIdSet.forEach(classifyId => {
        const fullCategory = this.allCategories.find(cat => cat.classify_id == classifyId)
        if (fullCategory) {
          // 使用完整的分类信息，并标记为相关分类
          relatedCategories.push({
            ...fullCategory,
            isRelated: true
          })
        } else {
          console.warn(`未找到分类ID ${classifyId} 的完整信息，allCategories中的分类ID:`, this.allCategories.map(c => c.classify_id))
        }
      })
      
      console.log('找到的相关分类:', relatedCategories)
      
      if (relatedCategories.length === 0) {
        this.$message.warning('未找到相关分类')
        return
      }
      
      // 分离出新分类和已存在的分类
      const newCategories = []
      const existingCategories = []
      
      relatedCategories.forEach(related => {
        const existingIndex = this.categories.findIndex(existing => existing.classify_id == related.classify_id)
        if (existingIndex >= 0) {
          // 已存在的分类，从原位置移除并标记为相关
          const existingCategory = this.categories[existingIndex]
          existingCategories.push({
            ...existingCategory,
            isRelated: true
          })
          // 从原位置移除
          this.categories.splice(existingIndex, 1)
        } else {
          // 新分类
          newCategories.push(related)
        }
      })
      
      // 初始化新分类的状态
      if (newCategories.length > 0) {
        newCategories.forEach(category => {
          this.$set(this.keywordsByCategory, category.classify_id, [])
          this.$set(this.currentPage, category.classify_id, 1)
          this.$set(this.hasMore, category.classify_id, true)
          this.$set(this.loading, category.classify_id, false)
          this.$set(this.keywordsCounts, category.classify_id, 0)
        })
      }
      
      // 将所有相关分类（包括已存在的和新的）都移到最前面
      const allRelatedCategories = [...existingCategories, ...newCategories]
      this.categories = [...allRelatedCategories, ...this.categories]
      
      // 获取新分类的词条数据
      if (newCategories.length > 0) {
        await this.fetchCategoriesKeywords(newCategories)
      }
      
      // 查找所有包含高亮关键词的分类并移到前面
      await this.$nextTick()
      const categoriesWithHighlights = this.findCategoriesWithHighlightKeywords()
      if (categoriesWithHighlights.length > 0) {
        this.moveCategoriesWithHighlightsToFront(categoriesWithHighlights, allRelatedCategories)
      }
      
      // 延迟绘制连接线，确保DOM渲染完成
      this.$nextTick(() => {
        setTimeout(() => {
          this.drawConnectionLines()
        }, 500)
      })
      
      // 构建搜索成功提示信息
      const keywordCount = this.highlightKeywords.length
      const categoryCount = allRelatedCategories.length + categoriesWithHighlights.length
      
      let message = `成功搜索到 ${keywordCount} 个词条`
      
      if (categoryCount > 0) {
        message += `，涉及 ${categoryCount} 个分类`
      }
      
      this.$message.success(message)
    },
    
    // 查找包含高亮关键词的分类
    findCategoriesWithHighlightKeywords() {
      const categoriesWithHighlights = []
      
      // 遍历所有分类，检查是否包含高亮关键词
      this.categories.forEach(category => {
        // 跳过已经标记为相关的分类
        if (category.isRelated) {
          return
        }
        
        const keywords = this.keywordsByCategory[category.classify_id] || []
        const hasHighlightKeyword = keywords.some(keyword => 
          this.highlightKeywords.includes(keyword.keywords)
        )
        
        if (hasHighlightKeyword) {
          categoriesWithHighlights.push(category)
        }
      })
      
      console.log('找到包含高亮词条的分类:', categoriesWithHighlights)
      return categoriesWithHighlights
    },
    
    // 将包含高亮词条的分类移到前面
    moveCategoriesWithHighlightsToFront(categoriesWithHighlights, relatedCategories) {
      // 从categories中移除这些分类
      categoriesWithHighlights.forEach(category => {
        const index = this.categories.findIndex(c => c.classify_id === category.classify_id)
        if (index >= 0) {
          this.categories.splice(index, 1)
        }
      })
      
      // 将这些分类插入到相关分类之后
      // 顺序：相关分类 -> 包含高亮词条的分类 -> 其他分类
      this.categories = [
        ...relatedCategories,
        ...categoriesWithHighlights,
        ...this.categories
      ]
    },
    
    // 搜索框获得焦点
    handleSearchFocus() {
      // 如果有搜索内容和结果，显示下拉框
      if (this.searchQuery && this.searchResults.length > 0) {
        this.showDropdown = true
      }
    },
    
    // 搜索框失去焦点
    handleSearchBlur() {
      // 延迟隐藏下拉框，给点击事件留时间
      setTimeout(() => {
        this.showDropdown = false
      }, 200)
    },
    
    // 静默清除相关分类（不显示提示信息）
    clearRelatedCategoriesQuietly() {
      // 清除高亮关键词
      this.highlightKeywords = []
      // 清除连接线
      this.connectionLines = []
      
      // 移除相关分类
      this.categories = this.categories.filter(category => !category.isRelated)
      
      // 清理相关分类的数据
      Object.keys(this.keywordsByCategory).forEach(classifyId => {
        const category = this.allCategories.find(cat => cat.classify_id == classifyId)
        if (!category && this.keywordsByCategory[classifyId]) {
          this.$delete(this.keywordsByCategory, classifyId)
          this.$delete(this.currentPage, classifyId)
          this.$delete(this.hasMore, classifyId)
          this.$delete(this.loading, classifyId)
          this.$delete(this.keywordsCounts, classifyId)
        }
      })
    },
    
    // 绘制连接线
    drawConnectionLines() {
      if (this.highlightKeywords.length < 2) {
        this.connectionLines = []
        return
      }
      
      // 获取容器尺寸
      const container = this.$el.querySelector('.keywords-content')
      if (!container) return
      
      this.containerWidth = container.scrollWidth
      this.containerHeight = container.clientHeight
      
      // 获取所有高亮关键词元素的位置
      const highlightedElements = []
      this.highlightKeywords.forEach(keyword => {
        const elements = container.querySelectorAll('.keyword-item.highlighted')
        elements.forEach(el => {
          if (el.textContent.trim() === keyword) {
            const rect = el.getBoundingClientRect()
            const containerRect = container.getBoundingClientRect()
            highlightedElements.push({
              keyword,
              x: rect.left - containerRect.left + rect.width / 2,
              y: rect.top - containerRect.top + rect.height / 2,
              element: el
            })
          }
        })
      })
      
      // 生成连接线路径
      this.connectionLines = []
      for (let i = 0; i < highlightedElements.length - 1; i++) {
        const start = highlightedElements[i]
        const end = highlightedElements[i + 1]
        
        // 计算贝塞尔曲线控制点（向下凸）
        const controlPoint1X = start.x + (end.x - start.x) * 0.3
        const controlPoint1Y = start.y + 80  // 向下偏移
        const controlPoint2X = start.x + (end.x - start.x) * 0.7
        const controlPoint2Y = end.y + 80    // 向下偏移
        
        // 生成SVG路径
        const path = `M ${start.x} ${start.y} C ${controlPoint1X} ${controlPoint1Y}, ${controlPoint2X} ${controlPoint2Y}, ${end.x} ${end.y}`
        
        this.connectionLines.push({
          path,
          startKeyword: start.keyword,
          endKeyword: end.keyword
        })
      }
    },
    
    // 监听窗口大小变化，重新绘制连接线
    handleResize() {
      if (this.highlightKeywords.length > 1) {
        this.$nextTick(() => {
          this.drawConnectionLines()
        })
      }
    },
    
    // 显示第一个高亮词条的描述框
    showFirstHighlightedKeywordPopover() {
      if (this.highlightKeywords.length === 0) {
        return
      }
      
      // 查找第一个高亮的词条
      const container = this.$el.querySelector('.keywords-content')
      if (!container) return
      
      // 遍历所有分类，找到第一个包含高亮词条的分类
      for (let i = 0; i < this.categories.length; i++) {
        const category = this.categories[i]
        const keywords = this.keywordsByCategory[category.classify_id] || []
        
        // 在当前分类中查找第一个高亮的词条
        const highlightedKeyword = keywords.find(keyword => 
          this.highlightKeywords.includes(keyword.keywords)
        )
        
        if (highlightedKeyword) {
          // 找到了第一个高亮词条，触发点击事件显示描述框
          // 通过触发子组件的点击事件来显示弹窗
          this.$nextTick(() => {
            // 查找对应的词条元素
            const keywordElement = container.querySelector(
              `.keyword-item.highlighted[title="${highlightedKeyword.keywords}"]`
            )
            
            if (keywordElement) {
              // 滚动到该词条位置
              keywordElement.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'center',
                inline: 'center'
              })
              
              // 触发点击事件
              setTimeout(() => {
                keywordElement.click()
              }, 300) // 等待滚动完成
            }
          })
          
          // 找到第一个就退出循环
          break
        }
      }
    }
  }
}
